import { WebPlugin } from '@capacitor/core';

import type { NetWorkPlugin, ProtocolType } from './definitions';


export class NetWorkWeb extends WebPlugin implements NetWorkPlugin {
  async getIpInfo(): Promise<{ ip: string; ipv4: string; ipv6: string; }> {
    return { ip: '--', ipv4: '--', ipv6: '--' }
  }

  async connect(options: { type: ProtocolType, ip: string, port: number }): Promise<void> {
    console.log('Web connect', options);
  }

  async send(options: { data: any }): Promise<void> {
    console.log('Web send', options);
  }

  onData(callback: (data: any) => void): void {
    // Web端可用setTimeout模拟接收数据
    setTimeout(() => callback({ msg: '模拟数据' }), 1000);
  }

  async disconnect(): Promise<void> {
    console.log('Web disconnect');
  }
}
